import { render, staticRenderFns } from "./relevance.vue?vue&type=template&id=e16abb22&scoped=true&"
import script from "./relevance.vue?vue&type=script&lang=js&"
export * from "./relevance.vue?vue&type=script&lang=js&"
import style0 from "./relevance.vue?vue&type=style&index=0&id=e16abb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16abb22",
  null
  
)

export default component.exports